import { render, staticRenderFns } from "./topBanners.vue?vue&type=template&id=042b6dec"
import script from "./topBanners.vue?vue&type=script&lang=js"
export * from "./topBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports